(() => {
  const route = document.getElementById('jw-route');
  const desktop = matchMedia('(min-width:701px)');
  const snapshots = new Map();
  let request = 0;
  let controller;
  let looping = false;
  let frame = false;
  function update() {
    frame = false;
    const content = document.getElementById('jw-content');
    if (!content || content.dataset.page !== 'index') return;
    const anchor = content.querySelector('.selected-anchor');
    const selected = content.querySelector('.selected-works');
    if (anchor && selected) selected.classList.toggle('is-latched', anchor.getBoundingClientRect().top <= 0);
    const vh = innerHeight;
    content.querySelectorAll('.art').forEach(el => {
      const box = el.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, 1 - Math.abs(box.top + box.height / 2 - vh / 2) / (vh * .62)));
      el.style.opacity = (.25 + progress * .75).toFixed(3);
      el.style.transform = `translateY(${((1 - progress) * 28).toFixed(1)}px)`;
    });
    if (!looping && innerHeight + scrollY >= document.documentElement.scrollHeight - 3) {
      looping = true;
      requestAnimationFrame(() => {
        if (document.body.dataset.page === 'index') scrollTo(0, 0);
        setTimeout(() => { looping = false; }, 60);
      });
    }
  }
  function refreshPage(scroll = 0) {
    const content = document.getElementById('jw-content');
    document.body.dataset.page = content?.dataset.page || 'page';
    scrollTo(0, scroll);
    update();
  }
  function save() {
    const state = history.state;
    if (!state?.jw) return;
    snapshots.set(state.key, {html: route.innerHTML, title: document.title, scroll: scrollY});
    if (snapshots.size > 30) snapshots.delete(snapshots.keys().next().value);
  }
  async function load(url, push, state) {
    if (!desktop.matches) { location.assign(url); return; }
    save();
    const token = ++request;
    controller?.abort();
    controller = new AbortController();
    try {
      const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Page unavailable');
      const html = await response.text();
      if (token !== request) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.getElementById('jw-route');
      if (!next?.querySelector('#jw-content')) throw new Error('Native page required');
      if (push) history.pushState({jw:true, key: Date.now() + Math.random(), depth:(history.state?.depth || 0) + 1}, '', url);
      route.innerHTML = next.innerHTML;
      document.title = doc.title;
      refreshPage(state?.scroll || 0);
      save();
    } catch (error) {
      if (error.name !== 'AbortError' && token === request) location.assign(url);
    }
  }
  document.addEventListener('click', event => {
    const pause = event.target.closest('.jw-tba-pause');
    if (pause) {
      const paused = pause.closest('.jw-tba-stage').classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Resume moving TBA text' : 'Pause moving TBA text');
      pause.textContent = paused ? '▶' : 'Ⅱ';
      return;
    }
    const back = event.target.closest('[data-jw-back]');
    if (back) { event.preventDefault(); save(); if (history.length > 1) history.back(); else location.assign(document.querySelector('.jw-controls a').href); return; }
    if (!desktop.matches || window.Shopify?.designMode || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.hash || !(/\/pages\//.test(url.pathname) || url.pathname === document.querySelector('.jw-controls a').pathname)) return;
    // Preserve Shopify draft-theme context when links use clean storefront URLs.
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    event.preventDefault();
    if (url.href === location.href) { scrollTo(0, 0); update(); return; }
    load(url.href, true);
  });
  if (desktop.matches && !window.Shopify?.designMode) {
    history.scrollRestoration = 'manual';
    history.replaceState({jw:true,key:Date.now(),depth:0}, '', location.href);
  }
  addEventListener('popstate', () => {
    if (!desktop.matches || !history.state?.jw) return;
    request++; controller?.abort();
    const snapshot = snapshots.get(history.state.key);
    if (snapshot) { route.innerHTML = snapshot.html; document.title = snapshot.title; refreshPage(snapshot.scroll); }
    else load(location.href, false);
  });
  addEventListener('scroll', () => { if (!frame) { frame = true; requestAnimationFrame(update); } }, {passive:true});
  addEventListener('resize', update);
  document.addEventListener('shopify:section:load', update);
  addEventListener('load', update);
  refreshPage(scrollY);
  save();
})();
